"use client";
import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

export function useCancellationConfirmation() {
  const [message, setMessage] = useState<string | null>(null);
  const dialog = useRef<HTMLDialogElement>(null);
  const answer = useRef<((value: boolean) => void) | null>(null);
  useEffect(
    () => () => {
      answer.current?.(false);
    },
    [],
  );
  useEffect(() => {
    if (message) dialog.current?.showModal();
  }, [message]);
  const finish = (value: boolean) => {
    answer.current?.(value);
    answer.current = null;
    dialog.current?.close();
    setMessage(null);
  };
  const confirm = (text: string) =>
    new Promise<boolean>((resolve) => {
      answer.current?.(false);
      answer.current = resolve;
      setMessage(text);
    });
  const confirmationDialog =
    message &&
    createPortal(
      <dialog
        ref={dialog}
        className="cancellation-confirmation"
        aria-label="確認操作"
        onCancel={(e) => {
          e.preventDefault();
          finish(false);
        }}
      >
        <h3>確認操作</h3>
        <p>{message}</p>
        <div className="secondary-actions">
          <button type="button" onClick={() => finish(false)}>
            返回
          </button>
          <button type="button" onClick={() => finish(true)}>
            確認
          </button>
        </div>
      </dialog>,
      document.body,
    );
  return { confirm, confirmationDialog };
}
